import React from 'react';
import { createJBrowseTheme as coreCreateJBrowseTheme } from '@jbrowse/core/ui';
export function createJBrowseTheme(theme) {
  console.warn('Deprecation warning: `createJBrowseTheme` will be removed in a future ' + 'release. It can be imported from @jbrowse/core/ui if needed.');
  return coreCreateJBrowseTheme(theme);
}
export function ThemeProvider(_ref) {
  var _theme = _ref._theme,
    children = _ref.children;
  console.warn('Deprecation warning: `ThemeProvider` is no longer supported as a way to ' + 'theme @jbrowse/react-linear-genome-view. If using a custom theme, ' + 'please pass the theme in to the "configuration" of `createViewState` ' + 'instead.');
  return React.createElement(React.Fragment, null, children);
}